import React from 'react';


export default function RequiredText({ children }) {
    return (<span style={{ color: '#ff0000', marginLeft: "0.5rem", fontSize: "0.8rem" }}>{children}</span>)
}